/**
 * Directiva para utilizar el selectmenu de jquery
 * @example
 *      <sigo-selectmenu
 ng-model="tecnicoSeleccionado"
 ng-change="cambiaTecnico(tecnicoSeleccionado)"
 ng-options="tecnico.codusuario as tecnico.nombre + ' [' +tecnico.nombre + ' ' + tecnico.apellidos +']' for tecnico in tecnicos">
 </sigo-selectmenu>
 */
selectmenu.$inject = [];
export default function selectmenu() {
    function numeroToValor(numero) {
        var tipo = typeof numero;
        var valor = tipo + ":" + numero;
        return valor;
    }

    function valorToNumero(valor) {
        if (valor == '' || typeof valor === 'undefined') return valor;
        if (valor.indexOf(":") === -1) return valor;

        var res = valor.split(":");
        var tipo = res[0];
        var numero = res[1];
        return numero;
    }

    return {
        restrict: 'AE',
        require: 'ngModel',
        replace: true,
        transclude: true,
        template: '<select ng-transclude></select>',
        link: function (scope, element, attrs, ngModelCtrl) {
            $(function () {
                scope.$evalAsync(function () {
                    element.selectmenu({
                        width: '100%',
                        change: function (event, data) {
                            // Actualiza el modelo, cuando se actualiza el selectmenu
                            scope.$apply(function () {
                                ngModelCtrl.$setViewValue(valorToNumero(data.item.value));
                            });
                        }
                    });
                    ngModelCtrl.$render = function model2view() {
                        //Actualizamos el selectmenu cuando se actualiza el modelo
                        var valorSeleccionado = numeroToValor(ngModelCtrl.$viewValue);
                        element.selectmenu('refresh', true);
                        element.val(valorSeleccionado);
                        element.selectmenu('refresh', true);
                    }
                });
            });
        }
    }
}